var _defs, _defs2, _defs3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3485.1926,
    y1: 3298.6335,
    x2: 1394.525,
    y2: 1469.3008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M3133.609,2346.625c-271.001,633.674-992.884,988.662-1618.902,892.906 c-101.866-15.582-381.134-61.997-628.387-280.967C410.34,2537.03,308.548,1702.338,692.506,1114.111 C971.96,685.985,1472.91,443.295,1948.91,455.435c102.531,2.615,495.47,18.73,840.796,301.504 c50.721,41.534,162.593,140.23,263.416,296.805C3289.873,1421.411,3310.223,1933.652,3133.609,2346.625z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#91B3FA"
    },
    cx: 2747.993,
    cy: 1241.688,
    r: 443.276
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000062180509758070148490000009085408127482352795_",
    cx: 2747.689,
    cy: 1242.029,
    r: 422.061
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053530055758915228790000004269810730924483719_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062180509758070148490000009085408127482352795_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000053530055758915228790000004269810730924483719_)",
      fill: "#FFFFFF"
    },
    d: "M3276.556,1773.279 l-1021.961,33.361c-6.165,0.201-11.374-4.678-11.575-10.844L2206.196,667.74c-0.201-6.165,4.678-11.374,10.844-11.575 L3239,622.804c6.165-0.201,11.374,4.678,11.575,10.844l36.824,1128.057C3287.601,1767.869,3282.722,1773.078,3276.556,1773.279z "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053530055758915228790000004269810730924483719_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088817512202959889920000004228991524965789081_",
    gradientUnits: "userSpaceOnUse",
    x1: 3293.2861,
    y1: 970.901,
    x2: 2385.8037,
    y2: 2047.6895,
    gradientTransform: "matrix(0.9995 -0.0326 0.0326 0.9995 -11.662 -7.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088817512202959889920000004228991524965789081_)"
    },
    d: "M2530.531,1293.92 c0,0,255.682-48.97,460.348-1.486l-6.683,210.105c0,0-44.613,292.589-80.998,422.418c0,0-154.674,32.131-230.395-6.02 c0,0-72.792-363.233-108.375-416.236C2564.428,1502.7,2525.975,1361.774,2530.531,1293.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122722889870615997880000003054711985887937196_",
    gradientUnits: "userSpaceOnUse",
    x1: 2792.7527,
    y1: 1473.3472,
    x2: 2704.71,
    y2: 1066.996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122722889870615997880000003054711985887937196_)"
    },
    d: "M2703.037,1103.286l-19.95,173.977 c0,0,72.602,30.524,121.57-5.38l-14.773-121.84L2703.037,1103.286z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072273668318138366730000015291548995006458759_",
    gradientUnits: "userSpaceOnUse",
    x1: 15581.4453,
    y1: -1911.9,
    x2: 15794.6064,
    y2: -1963.7805,
    gradientTransform: "matrix(0.8595 -0.5111 0.5111 0.8595 157.6643 1082.0952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072273668318138366730000015291548995006458759_)"
    },
    d: "M2809.592,986.944 c0.854,1.437,19.136,88.241,30.399,141.975c4.654,22.202-11.083,43.48-33.672,45.559l-20.685,1.904 c-38.006,3.497-72.425-22.519-79.427-60.038l-18.181-97.41C2688.026,1018.934,2788.857,952.075,2809.592,986.944z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173122947220230639480000018360074176039005865_",
    gradientUnits: "userSpaceOnUse",
    x1: 2151.6038,
    y1: 1257.1316,
    x2: 2371.1606,
    y2: 1257.1316,
    gradientTransform: "matrix(0.8595 -0.5111 0.5111 0.8595 157.6643 1082.0952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173122947220230639480000018360074176039005865_)"
    },
    d: "M2665.689,1019.905 c-8.268-9.622-15.719-25.373,0.655-42.726c16.575-17.57,36.149-13.964,48.664-8.662c5.538,2.347,12.226,1.009,15.961-3.709 c1.66-2.095,4.176-3.567,7.99-3.264c7.193,0.57,13.437-4.371,14.054-11.56c1.057-12.325,7.126-26.995,28.697-31.898 c39.563-8.996,60.726,30.202,60.931,58.231c0.205,28.027-43.244,35.342-68.156,31.502 c-18.299-2.821-33.503,13.674-40.285,22.63c-2.462,3.25-3.284,7.431-2.231,11.37l7.177,26.849 c-4.085,8.553-8.083,17.282-13.972,24.658c-4.241,5.312-8.983,8.321-14.07,9.695c-7.875-13.576-28.713-15.241-38.372-15.236 c-3.696,0.003-7.196-1.512-9.714-4.217c-7.552-8.111-19.554-26.365,1.658-45.367 C2669.951,1033.48,2670.303,1025.276,2665.689,1019.905z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058576118021082505000000014273374784586086806_",
    gradientUnits: "userSpaceOnUse",
    x1: 15573.8926,
    y1: -1942.7665,
    x2: 15787.0537,
    y2: -1994.647,
    gradientTransform: "matrix(0.8595 -0.5111 0.5111 0.8595 157.6643 1082.0952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058576118021082505000000014273374784586086806_)"
    },
    d: "M2719.23,1131.754 c0,0-2.453-48.825-22.375-52.768c-19.922-3.943-40.787,11.048-22.922,39.744 C2696.156,1154.425,2719.23,1131.754,2719.23,1131.754z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049187950270677389110000000850397820771313073_",
    gradientUnits: "userSpaceOnUse",
    x1: 3200.2356,
    y1: 892.5105,
    x2: 2292.7644,
    y2: 1969.2859,
    gradientTransform: "matrix(0.9995 -0.0326 0.0326 0.9995 -11.662 -7.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049187950270677389110000000850397820771313073_)"
    },
    d: "M2530.531,1293.92 c0,0-384.906,445.879,90.555,596.236l-1.104-33.816c0,0-180.704-143.053-52.061-350.368 C2567.92,1505.972,2544.72,1313.769,2530.531,1293.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158731709981703910960000016537334290073628304_",
    gradientUnits: "userSpaceOnUse",
    x1: 2680.967,
    y1: 1913.7144,
    x2: 2464.4294,
    y2: 2098.6733,
    gradientTransform: "matrix(0.9995 -0.0326 0.0326 0.9995 -11.662 -7.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158731709981703910960000016537334290073628304_)"
    },
    d: "M2623.473,1859.611 c0,0,59.545-42.567,87.04-29.923c27.495,12.643,28.157,32.933,28.157,32.933s-12.644,27.495-33.154,21.394 c-20.511-6.101-67.412,8.972-87.923,2.87C2617.593,1886.885,2609.946,1860.053,2623.473,1859.611z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132798489521678607350000000871650368785847967_",
    gradientUnits: "userSpaceOnUse",
    x1: 3460.2366,
    y1: 1111.6133,
    x2: 2552.7661,
    y2: 2188.3877,
    gradientTransform: "matrix(0.9995 -0.0326 0.0326 0.9995 -11.662 -7.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132798489521678607350000000871650368785847967_)"
    },
    d: "M2990.879,1292.434 c0,0,429.633,405.748-35.009,586.794l-1.104-33.816c0,0,170.99-154.534,29.099-353.018 C2983.865,1492.394,2964.929,1327.133,2990.879,1292.434z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009572920774603642100000013921119656231242658_",
    gradientUnits: "userSpaceOnUse",
    x1: 2811.2539,
    y1: 1923.6772,
    x2: 2933.0532,
    y2: 2045.4764,
    gradientTransform: "matrix(0.9995 -0.0326 0.0326 0.9995 -11.662 -7.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009572920774603642100000013921119656231242658_)"
    },
    d: "M2951.494,1848.903 c0,0-62.195-38.593-88.806-24.183c-26.611,14.409-25.949,34.699-25.949,34.699s14.409,26.612,34.479,19.186 c20.069-7.426,67.854,4.556,87.923-2.87C2959.141,1875.736,2965.021,1848.462,2951.494,1848.903z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#91B3FA"
    },
    cx: 1770.302,
    cy: 1001.32,
    r: 443.276
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000139283087148862161560000011873241138543191993_",
    cx: 1769.998,
    cy: 1001.661,
    r: 422.061
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044148457497626265070000011289771157360075944_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139283087148862161560000011873241138543191993_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000044148457497626265070000011289771157360075944_)",
      fill: "#FFFFFF"
    },
    d: "M2298.865,1532.911 l-1021.961,33.361c-6.165,0.201-11.374-4.678-11.575-10.844l-36.825-1128.057c-0.201-6.165,4.678-11.374,10.844-11.575 l1021.961-33.361c6.165-0.201,11.374,4.678,11.575,10.844l36.824,1128.057C2309.91,1527.501,2305.031,1532.71,2298.865,1532.911 z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044148457497626265070000011289771157360075944_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163790827327342232410000001131513011345168056_",
    gradientUnits: "userSpaceOnUse",
    x1: -3891.4241,
    y1: 884.472,
    x2: -3430.8313,
    y2: 1520.0016,
    gradientTransform: "matrix(-0.9993 0.0357 0.0357 0.9993 -1970.2181 20.0975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163790827327342232410000001131513011345168056_)"
    },
    d: "M1751.759,811.466 c0,0,8.198,15.031-40.774,40.723c-27.306,14.326-80.649,35.965-85.727,93.791c-2.621,29.853-23.766,54.444-53.21,60.038 c-73.334,13.932-185.602,56.276-199.215,184.946c-10.391,98.212,40.747,133.489,93.483,144.447 c38.734,8.051,65.586,44.488,59.2,83.531c-6.121,37.449,6.52,80.035,72.149,111.729 c147.069,71.018,282.07-190.745,282.07-190.745l13.557-449.128L1751.759,811.466z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131347489975074586000000009364646967992711830_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.7683,
    y1: 1261.2969,
    x2: 2028.8002,
    y2: 1261.2969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131347489975074586000000009364646967992711830_)"
    },
    d: "M1786.373,1454.559 c39.134-197.009-81.605-303.336-81.605-303.336c57.188-58.954,154.376-94.413,190.359-106.072 c8.826-2.859,18.432-1.237,25.854,4.331c32.084,24.072,117.209,94.258,106.969,154.353 c-7.373,43.29-80.876,260.611-80.876,260.611S1873.301,1502.636,1786.373,1454.559z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090990391713566373590000018186373979497640094_",
    gradientUnits: "userSpaceOnUse",
    x1: -7829.0195,
    y1: 1378.0129,
    x2: -7800.8701,
    y2: 1172.0792,
    gradientTransform: "matrix(-0.9993 0.0357 0.0357 0.9993 -5987.8721 163.4446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090990391713566373590000018186373979497640094_)"
    },
    d: "M1820.698,914.758l-31.478,169.708 c-3.06,14.958,10.374,12.05,25.267,8.687c24.39-5.505,55.698-16.169,65.595-35.653c1.006-1.982,1.466-4.2,1.692-6.414 l11.938-117.327c0.948-9.307-4.38-18.119-13.063-21.604l-31.567-12.67C1836.927,894.606,1823.322,901.927,1820.698,914.758z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146494882711204625850000006721253674982345385_",
    gradientUnits: "userSpaceOnUse",
    x1: -7743.564,
    y1: -281.2002,
    x2: -7497.958,
    y2: -718.2959,
    gradientTransform: "matrix(-0.9872 -0.1592 -0.1592 0.9872 -5763.1143 56.2078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146494882711204625850000006721253674982345385_)"
    },
    d: "M1887.018,758.708 c0,0,40.871,25.59,60.472,93.77c19.6,68.181-7.385,93.852-36.004,93.358c-28.619-0.494-70.351-7.848-107.996-55.921 C1765.844,841.844,1833.547,727.566,1887.018,758.708z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182521435270831387310000003130437411301847741_",
    gradientUnits: "userSpaceOnUse",
    x1: -3847.3059,
    y1: 806.6292,
    x2: -3366.2139,
    y2: 1470.4435,
    gradientTransform: "matrix(-0.9993 0.0357 0.0357 0.9993 -1970.2181 20.0975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182521435270831387310000003130437411301847741_)"
    },
    d: "M1838.687,860.878 c0,0-18.138-98.05,64.241-85.893l17.162,16.638c0,0,38.449-46.543-7.098-79.063c-45.547-32.519-106.752-21.592-138.573,41.704 c-31.819,63.298-42.615,107.363-12.712,144.923c29.904,37.559,50.182,3.708,50.182,3.708s-14.275-32.922-3.93-47.638 c10.344-14.714,25.157,7.445,25.157,7.445L1838.687,860.878z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026862837761264649070000012726003451978365606_",
    gradientUnits: "userSpaceOnUse",
    x1: -7691.2822,
    y1: -251.8247,
    x2: -7445.6831,
    y2: -688.9081,
    gradientTransform: "matrix(-0.9872 -0.1592 -0.1592 0.9872 -5763.1143 56.2078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026862837761264649070000012726003451978365606_)"
    },
    d: "M1827.803,869.719 c0,0-9.027-50.457-34.412-35.034c-25.384,15.422,11.026,47.041,25.552,57.723L1827.803,869.719z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023273020550317322890000013213918727396663223_",
    gradientUnits: "userSpaceOnUse",
    x1: 1616.0834,
    y1: 1317.6395,
    x2: 1810.6002,
    y2: 1317.6395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023273020550317322890000013213918727396663223_)"
    },
    d: "M1704.337,1154.113 c0,0-75.021,130.14-87.528,226.184c-12.506,96.044,140.085,130.432,193.791,72.75l-9.376-39.498 c0,0-86.952,19.035-96.612-28.42c-9.659-47.453,66.498-145.769,66.498-145.769S1744.687,1168.606,1704.337,1154.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1482.088,1277.722c-2.267,0.038-4.832-0.933-6.929-2.189 c-34.608-20.843-54.271-65.668-47.814-109.006c3.87-25.969,15.874-48.678,33.803-63.958 c12.718-10.832,28.006-17.7,42.577-23.813c24.55-10.294,49.896-19.498,75.338-27.356c2.08-0.639,4.166-1.278,6.253-1.917 c14.862-4.527,30.232-9.209,44.009-16.725c17.62-9.629,30.227-23.147,35.498-38.069c3.278-9.277,3.958-19.484,4.612-29.349 c0.807-12.146,1.641-24.709,7.336-35.659c0.229-0.434,0.754-0.596,1.198-0.381c0.434,0.229,0.603,0.768,0.378,1.202 c-5.523,10.621-6.344,22.989-7.139,34.954c-0.662,9.984-1.347,20.315-4.708,29.83c-5.417,15.328-18.316,29.19-36.322,39.028 c-13.939,7.609-29.395,12.32-44.343,16.877c-2.083,0.632-4.17,1.265-6.249,1.911c-25.383,7.843-50.674,17.025-75.173,27.297 c-14.441,6.055-29.591,12.858-42.11,23.527c-17.603,14.997-29.392,37.321-33.196,62.865 c-6.357,42.65,12.96,86.744,46.971,107.215c2.448,1.48,7.086,3.242,8.901,0.503c0.278-0.414,0.828-0.521,1.232-0.257 c0.407,0.278,0.521,0.825,0.25,1.232C1485.418,1277.062,1483.841,1277.693,1482.088,1277.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1472.094,1237.562c-0.281,0.005-0.558-0.123-0.735-0.37 c-13.737-19.034-21.257-39.263-21.746-58.498c-0.577-22.568,9.152-43.919,25.388-55.72c0.402-0.278,0.955-0.203,1.243,0.194 s0.2,0.955-0.198,1.246c-15.77,11.459-25.22,32.244-24.656,54.235c0.48,18.874,7.883,38.758,21.41,57.504 c0.288,0.398,0.197,0.955-0.201,1.24C1472.448,1237.507,1472.271,1237.559,1472.094,1237.562z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#91B3FA"
    },
    cx: 2809.244,
    cy: 2317.278,
    r: 443.276
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000065058359101268728900000009932068809342161289_",
    cx: 2808.941,
    cy: 2317.619,
    r: 422.061
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105428495847346510150000013753130089998723763_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065058359101268728900000009932068809342161289_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000105428495847346510150000013753130089998723763_)",
      fill: "#FFFFFF"
    },
    d: "M3337.808,2848.869 l-1021.961,33.361c-6.165,0.201-11.374-4.678-11.575-10.844l-36.824-1128.057c-0.201-6.165,4.678-11.374,10.844-11.575 l1021.961-33.361c6.165-0.201,11.374,4.678,11.575,10.844l36.825,1128.057 C3348.853,2843.459,3343.973,2848.668,3337.808,2848.869z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105428495847346510150000013753130089998723763_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158731754914128041260000017654301126562759344_",
    gradientUnits: "userSpaceOnUse",
    x1: 3115.782,
    y1: 968.5957,
    x2: 2953.4712,
    y2: 1303.1543,
    gradientTransform: "matrix(0.987 0.1608 -0.1608 0.987 126.9837 357.2448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158731754914128041260000017654301126562759344_)"
    },
    d: "M2734.725,2095.801 c-0.829,1.57-53.025,39.979-53.025,39.979s11.526,82.464,58.335,115.028c51.463,35.801,124.141-29.49,124.141-29.49 s57.84,13.75,88.599-106.651c7.057-27.623-33.678-29.958-82.841-24.871C2806.536,2096.358,2734.725,2095.801,2734.725,2095.801 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083809389002815940690000018410418093237694614_",
    gradientUnits: "userSpaceOnUse",
    x1: 2870.9541,
    y1: 2269.0022,
    x2: 2674.5525,
    y2: 3183.2888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083809389002815940690000018410418093237694614_)"
    },
    d: "M2637.161,2377.144 c20.42-14.04,42.997-24.625,66.931-31.138c8.991-2.447,57.532,11.662,87.54,10.972c41.191-0.947,83.118-19.692,117.072-11.231 c33.727,8.404,61.33,19.381,77.268,30.718c47.708,33.932,75.718,97.201,92.788,159.871 c-32.322,33.178-72.996,47.924-72.996,47.924l-7.516,304.627l-180.131,92.163l-205.599-103.222l7.365-297.693 c0,0-65.288-30.404-70.078-41.464C2545.013,2527.611,2579.56,2416.748,2637.161,2377.144z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088848664098178137590000009822861337384495256_",
    gradientUnits: "userSpaceOnUse",
    x1: 2508.1433,
    y1: 2472.1252,
    x2: 2850.4434,
    y2: 3298.9797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088848664098178137590000009822861337384495256_)"
    },
    d: "M2552.844,2537.341 c0,0-87.489,242.555,112.019,342.243c41.426-5.504,25.492-74.298,25.492-74.298s-86.688-19.184-60.653-221.521 C2605.734,2564.044,2552.844,2537.341,2552.844,2537.341z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171697877020803777360000018194056736748836531_",
    gradientUnits: "userSpaceOnUse",
    x1: -7282.0347,
    y1: 2470.3481,
    x2: -6939.7349,
    y2: 3297.2021,
    gradientTransform: "matrix(-1 0 0 1 -4167.0742 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171697877020803777360000018194056736748836531_)"
    },
    d: "M3074.552,2537.341 c0,0,60.201,253.194-112.018,342.243c-41.426-5.504-25.492-74.298-25.492-74.298s69.864-34.408,60.653-221.521 C3021.663,2564.044,3074.552,2537.341,3074.552,2537.341z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097466872184698345180000011945155953361686184_",
    gradientUnits: "userSpaceOnUse",
    x1: 2808.6335,
    y1: 2540.3962,
    x2: 2804.0791,
    y2: 2144.1265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097466872184698345180000011945155953361686184_)"
    },
    d: "M2704.092,2346.006 c0,0,18.202,78.88,106.576,77.241c90.011-1.638,98.036-77.5,98.036-77.5l-58.798-12.582l-4.914-65.515l-88.445,6.552 l-1.637,62.239L2704.092,2346.006z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013895736090463510810000000192692902805861817_",
    gradientUnits: "userSpaceOnUse",
    x1: 2949.3591,
    y1: 1508.5376,
    x2: 2963.5469,
    y2: 1163.7134,
    gradientTransform: "matrix(0.987 0.1608 -0.1608 0.987 126.9837 357.2448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013895736090463510810000000192692902805861817_)"
    },
    d: "M2768.965,2082.027 c0,0-101.358,196.334,18.875,243.968c84.807,33.598,137.98-130.381,122.12-174.795c-24.522-68.672-40.671-60.523-40.671-60.523 L2768.965,2082.027z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124126023256996297400000008417433090234436261_",
    gradientUnits: "userSpaceOnUse",
    x1: 3116.9705,
    y1: 921.511,
    x2: 2934.3364,
    y2: 1297.9606,
    gradientTransform: "matrix(0.987 0.1608 -0.1608 0.987 126.9837 357.2448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124126023256996297400000008417433090234436261_)"
    },
    d: "M2934.35,2064.161 c50.072,13.762,7.279,122.359-68.108,96.678c-75.387-25.68-105.011-25.306-116.759-4.604 c-11.747,20.7-14.271,94.213-39.76,57.878c-27.945-39.836-43.526-119.793-9.264-145.569 c30.621-23.036,37.768-58.752,74.495-57.514c48.75,1.643,86.45-19.966,108.455-4.382 C2908.681,2024.546,2897.506,2054.034,2934.35,2064.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098183781897915348850000013598048755615207559_",
    gradientUnits: "userSpaceOnUse",
    x1: 2407.7722,
    y1: 2927.6392,
    x2: 2430.0056,
    y2: 2387.2681,
    gradientTransform: "matrix(0.9911 -0.1329 0.1329 0.9911 -26.0254 -216.2621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098183781897915348850000013598048755615207559_)"
    },
    d: "M2744.848,2173.117 c0,0-21.617-23.259-25.077,4.774c-3.46,28.033,7.648,64.136,20.663,44.346 C2753.448,2202.449,2744.848,2173.117,2744.848,2173.117z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178889557015756279300000012212116358923999395_",
    gradientUnits: "userSpaceOnUse",
    x1: 2423.2219,
    y1: 1677.2642,
    x2: 1804.6636,
    y2: 2481.9912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178889557015756279300000012212116358923999395_)"
    },
    d: "M2752.082,1440.295 c0,0-193.436,42.664-311.09,96.985c-23.367,10.788-42.006,29.653-52.621,52.904c-35.187,77.079-140.464,270.365-344.63,362.606 c29.401,39.025,76.744,120.199,97.367,256.638c122.625-91.268,228.487-243.689,279.313-493.663c0,0,38.702,21.039,86.983-2.408 c25.508-12.389,54.96-29.96,77.069-43.78c22.028-13.77,38.436-35.175,44.808-60.174c8.415-33.01,3.458-62.038,3.458-93.178 l99.43-30.805C2732.169,1485.419,2762.058,1474.137,2752.082,1440.295z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148630783633235653380000001398903793448033693_",
    gradientUnits: "userSpaceOnUse",
    x1: 1054.6099,
    y1: 2605.106,
    x2: -994.4404,
    y2: 5033.6099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148630783633235653380000001398903793448033693_)"
    },
    d: "M708.189,2994.275 c28.487-70.724,61.367-127.576,89.483-169.342c-59.712-100.718-77.396-238.281,28.565-417.418 c77.263,208.628,113.51,513.044,121.085,647.763c1.421,25.271-6.423,64.466-13.436,93.516 c-5.059,20.958,8.343,41.972,29.509,46.071c159.062,30.805,312.455,45.112,452.68,21.101c20.65-3.536,37.154-19.22,41.783-39.653 c91.674-404.699,91.107-683.279,67.084-861.557c94.948,21.227,385.295,66.505,616.166-105.328 c-20.623-136.439-67.966-217.613-97.366-256.638c-126.832,57.302-291.815,75.622-501.905,2.821 c-19.364-6.71-39.566-10.638-60.048-11.842c-111.842-6.557-480.396-18.522-785.363,82.232 c-64.183,21.207-116.169,68.654-142.959,130.133C470.968,2345.454,337.405,2776.606,708.189,2994.275z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170276984518824668890000013480726371405699216_",
    gradientUnits: "userSpaceOnUse",
    x1: 2539.0178,
    y1: 830.8237,
    x2: 1441.8718,
    y2: 2246.2759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170276984518824668890000013480726371405699216_)"
    },
    d: "M1525.353,2326.255 c-4.184,0-7.821-3.098-8.384-7.354c-23.841-180.073-72.383-258.66-72.866-259.432c-2.494-3.951-1.32-9.181,2.631-11.683 c3.935-2.478,9.165-1.328,11.667,2.615c2.076,3.259,50.956,81.95,75.352,266.28c0.611,4.635-2.647,8.891-7.282,9.502 C1526.094,2326.231,1525.723,2326.255,1525.353,2326.255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111175302426551416250000006636014134217913534_",
    gradientUnits: "userSpaceOnUse",
    x1: 1044.47,
    y1: 2197.3711,
    x2: 1112.1411,
    y2: 1842.0974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111175302426551416250000006636014134217913534_)"
    },
    d: "M1010.226,1694.624 c0,0-21.116,223.271-39.709,289.314c-2.821,10.02,1.532,20.585,10.635,25.786c31.555,18.031,107.24,47.44,210.764-3.297 c16.771-8.219,26.854-25.702,26.072-44.204l-9.122-215.752L1010.226,1694.624z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054254046779449270950000012013127085029048464_",
    gradientUnits: "userSpaceOnUse",
    x1: 1227.5784,
    y1: 1545.5562,
    x2: 841.4727,
    y2: 1840.9858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054254046779449270950000012013127085029048464_)"
    },
    d: "M1213.42,1408.989 c0,0,67.54,155.151,72.076,236.585c4.536,81.434,22.083,134.274-72.076,150.673s-173.48-30.507-216.452-111.625 c0,0-67.329-124.993-52.226-176.181C959.846,1457.252,1213.42,1408.989,1213.42,1408.989z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181794943600385270220000007906849959625506964_",
    gradientUnits: "userSpaceOnUse",
    x1: 955.777,
    y1: 1311.6404,
    x2: 1315.3737,
    y2: 1774.6202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181794943600385270220000007906849959625506964_)"
    },
    d: "M1029.144,1626.299l5.36-2.363 c6.824-3.008,9.743-11.13,6.315-17.754c-13.278-25.655-39.162-84.443-5.724-98.157 c43.094-17.674,213.796-52.485,250.626-113.055c35.397-58.214,4.034-133.358-43.101-154.732 c-3.154-1.43-6.873-0.295-8.491,2.767l-3.928,7.432c-2.689,5.088-10.203,4.317-11.803-1.211 c-1.536-5.307-8.594-6.336-11.521-1.651c-11.322,18.121-41.885,47.499-123.62,62.584 c-116.161,21.439-192.96,68.447-194.872,148.716c-0.122,5.1-5.546,7.935-9.902,5.28c-8.577-5.227-22.302-7.68-40.646,7.745 c-31.901,26.824-18.847,96.408,51.087,153.646c3.322,2.719,3.295,7.906-0.303,10.248c-12.679,8.253-31.578,27.891,17.393,54.069 c50.654,27.077,88.479,24.856,103.044,22.452c3.623-0.598,5.959-4.106,5.168-7.692l-15.546-70.549 c-0.88-3.993,2.16-7.775,6.248-7.775H1029.144z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016774908217290566950000003264402207600147846_",
    gradientUnits: "userSpaceOnUse",
    x1: 1179.6865,
    y1: 1482.9645,
    x2: 793.5805,
    y2: 1778.3945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016774908217290566950000003264402207600147846_)"
    },
    d: "M1032.069,1641.187 c0,0-25.766-99.108-70.201-71.32c-44.435,27.788,23.058,111.047,58.782,114.755L1032.069,1641.187z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005262399023343474830000004839197928234497703_",
    gradientUnits: "userSpaceOnUse",
    x1: 2597.5122,
    y1: 953.5807,
    x2: 2512.8562,
    y2: 1634.218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005262399023343474830000004839197928234497703_)"
    },
    d: "M2472.009,1692.708 c-1.875,0-3.766-0.62-5.335-1.899c-3.629-2.945-4.176-8.279-1.223-11.908c7.314-9.004,72.23-88.371,97.238-102.492 c9.1-5.141,14.523-10.452,15.674-15.352c0.555-2.342,0.185-4.973-1.135-7.966l-76.27,15.288l-43.216,37.077 c-3.532,3.049-8.891,2.647-11.932-0.909c-3.05-3.548-2.639-8.891,0.909-11.941l44.889-38.525 c1.102-0.941,2.422-1.585,3.846-1.875l84.436-16.921c3.387-0.684,6.783,0.74,8.69,3.573c6.188,9.181,8.239,17.718,6.26,26.086 c-2.333,9.889-10.122,18.466-23.825,26.206c-18.812,10.629-73.1,74.66-92.434,98.437 C2476.917,1691.646,2474.471,1692.708,2472.009,1692.708z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107567393670834831100000014200319781103922607_",
    gradientUnits: "userSpaceOnUse",
    x1: 635.9286,
    y1: 2852.4905,
    x2: 1496.0358,
    y2: 3238.522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107567393670834831100000014200319781103922607_)"
    },
    d: "M1028.79,3101.578l298.541,3.694 l-104.484-98.352c-25.97-24.446-65.61-28.406-95.588-8.962c-17.553,11.385-36.588,26.84-53.08,47.302 c0,0-186.229-68.058-276.506-220.33c-28.116,41.768-60.995,98.619-89.483,169.344 C789.118,3041.785,894.028,3079.144,1028.79,3101.578z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089575545143953861910000018088007390446998917_",
    gradientUnits: "userSpaceOnUse",
    x1: -3457.4844,
    y1: 2826.7327,
    x2: -4068.0056,
    y2: 2994.0605,
    gradientTransform: "matrix(-0.9988 -0.0494 -0.0494 0.9988 -2381.2668 -55.0328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089575545143953861910000018088007390446998917_)"
    },
    d: "M1060.956,3140.081 c0.579,0.028,1.159,0.044,1.743,0.04l757.813-0.818c18.734-0.015,33.903-15.058,33.884-33.594 c-0.019-18.542-15.276-33.859-33.959-33.526L1062.624,3073c-18.734,0.015-33.903,15.058-33.884,33.594 C1028.761,3124.552,1043.033,3139.204,1060.956,3140.081z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005985376393010412030000004308529018603705494_",
    gradientUnits: "userSpaceOnUse",
    x1: -4183.0879,
    y1: 2549.5239,
    x2: -4613.7334,
    y2: 3004.6897,
    gradientTransform: "matrix(-1 0 0 1 -2422.7358 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005985376393010412030000004308529018603705494_)"
    },
    d: "M2501.751,2459.301H1870.64 c-46.557,0-88.933,26.584-108.792,68.249l-291.762,612.13h784.303c30.003,0,56.959-18.138,67.987-45.746l226.249-566.436 C2561.697,2494.77,2537.319,2459.301,2501.751,2459.301z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.313 -0.9497 0.9497 0.313 -1202.4119 3914.1089)",
    style: {
      fill: "#7D97F4"
    },
    cx: 2104.457,
    cy: 2788.232,
    rx: 80.05,
    ry: 49.671
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/About.06bb9c8450dada24facc96a0477ef505.svg";
export { ForwardRef as ReactComponent };